<!-- <nh-alert type="warning" [isOpen]="showAlert()" [dismissible]="true">
<p> You are choosing to continue without providing a Social Security Number. If you do this your application may take longer to process.
</p>
</nh-alert> -->

<nh-alert type="warning" [isOpen]="showAlert()">
  <div class="row">
    <div class="col-auto icon">
      <img
        src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
        alt=""
      />
    </div>
    <div class="col message">
      <span>
        {{ "SSN_ENTER_MANDATORY" | globalTranslate }}
      </span>
    </div>
  </div>
</nh-alert>

<div class="d-none d-sm-block">
  @if (isRenewBenefits) {
  <p>{{ "RENEWAL_TEXT" | globalTranslate }}</p>
  }
  <h1 class="person-label">{{ selectedIndividual | fullname }}</h1>
</div>
<nh-form
  [individuals]="individuals"
  [formGroup]="getForm()"
  [mode]="mode"
  (validate)="onValidate($event)"
>
  <section [formGroup]="getControl('data')">
    <nh-field
      id="jf_jointFilerOutside"
      label="{{ 'IS_1' | globalTranslate }}{{
        selectedIndividual | fullname
      }} {{ 'JOIN_FILER_OUTSIDE_STATIC1' | globalTranslate }}"
      class="label-section"
    >
      <select
        nhTranslate
        name="jointFilerOutside"
        formControlName="jointFilerOutside"
        [items]="tableCodeValue('YESNO', 'data.jointFilerOutside')"
        [attr.aria-label]="
          ('IS_1' | globalTranslate) +
          '' +
          (selectedIndividual | fullname) +
          '' +
          ('JOIN_FILER_OUTSIDE_STATIC1' | globalTranslate)
        "
        (change)="jointFilerChange()"
        aria-required="true"
      ></select>
    </nh-field>
    @if (isY('data.jointFilerOutside')) {
    <div>
      <h2 class="section-header">
        {{ "JOIN_FILER_OUTSIDE_STATIC2" | globalTranslate }}
      </h2>
      <hr />
      <nh-field
        [attr.aria-required]="true"
        id="jf_name"
        [mandatory]="true"
        label="{{ 'JOIN_FILER_OUTSIDE_STATIC3' | globalTranslate }}"
        class="label-section"
      >
        <input
          type="text"
          class="form-control"
          formControlName="name"
          name="name"
          [attr.aria-label]="'JOIN_FILER_OUTSIDE_STATIC3' | globalTranslate"
          maxlength="45"
          (change)="jointFilerNameChange()"
          aria-required="true"
        />
      </nh-field>
      @if (translatedLang === 'en') {
      <nh-field
        [attr.aria-required]="false"
        id="jf_ssn"
        [mandatory]="false"
        label="{{ name.value }}{{ getSsnLabel(name.value) | globalTranslate }}"
        class="label-section"
      >
        <input
          type="text"
          class="form-control"
          formControlName="ssn"
          name="ssn"
          [attr.aria-label]="
            name.value + '' + (getSsnLabel(name.value) | globalTranslate)
          "
          placeholder="XXX-XX-XXXX"
          mask="000-00-0000"
        />
      </nh-field>
      } @if (translatedLang !== 'en') {
      <nh-field
        [attr.aria-required]="false"
        id="jf_ssn"
        [mandatory]="false"
        label="{{ 'JOIN_FILER_OUTSIDE_STATIC4' | translate }}{{ name.value }}{{
          getSsnLabel(name.value) | globalTranslate
        }}"
        class="label-section"
      >
        <input
          type="text"
          class="form-control"
          formControlName="ssn"
          name="ssn"
          [attr.aria-label]="
            ('JOIN_FILER_OUTSIDE_STATIC4' | translate) +
            '' +
            name.value +
            '' +
            (getSsnLabel(name.value) | globalTranslate)
          "
          placeholder="XXX-XX-XXXX"
          mask="000-00-0000"
        />
      </nh-field>
      } @if (translatedLang === 'en') {
      <nh-field
        [attr.aria-required]="false"
        id="jf_birthDate"
        label="{{ name.value }}{{ getDobLabel(name.value) | globalTranslate }}"
        class="label-section"
        [mandatory]="false"
      >
        <nh-datepicker>
          <input
            type="text"
            class="form-control"
            formControlName="birthDate"
            [maxDate]="today"
            [attr.aria-label]="
              name.value + '' + (getDobLabel(name.value) | globalTranslate)
            "
            bsDatepicker
            nh
            (change)="isInvalidDate($event)"
          />
        </nh-datepicker>
      </nh-field>
      } @if (translatedLang !== 'en') {
      <nh-field
        [attr.aria-required]="false"
        id="jf_birthDate"
        label="{{ 'JOIN_FILER_OUTSIDE_STATIC6' | translate }}{{ name.value }}{{
          getDobLabel(name.value) | globalTranslate
        }}"
        class="label-section"
        [mandatory]="false"
      >
        <nh-datepicker>
          <input
            type="text"
            class="form-control"
            formControlName="birthDate"
            [maxDate]="today"
            [attr.aria-label]="
              ('JOIN_FILER_OUTSIDE_STATIC6' | translate) +
              '' +
              name.value +
              '' +
              (getDobLabel(name.value) | globalTranslate)
            "
            bsDatepicker
            nh
            (change)="isInvalidDate($event)"
          />
        </nh-datepicker>
      </nh-field>

      }
    </div>
    }
  </section>
</nh-form>